<template>
    <div class="troops">            
            <ul>
              <li v-for="(group, i) in combatGroups" :key="i">
                {{getTraitGlyph(group.trait) }} {{ group.name || "troop " + group.troopId }}: {{ group.count }} 
              </li>
            </ul>
          </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from "vue";
import { ICombatGroup } from "../../game/shared/IMarchingArmy.ts";
import { getTraitGlyph } from "../../game/Helpers.ts";

export default defineComponent({
props: {
    combatGroups: {
        type: Object as PropType<ICombatGroup[]>,
        required: true,
    },
},
methods: {
    getTraitGlyph,
}});
</script>

<style>
ul {
    list-style: none;
    margin: 0;
    padding: 0;
}
</style>